import React from "react";
import PropTypes from "prop-types";
// *** Services
import { SessionActions, CertificadoActions } from "services";
// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";
import InputAdornment from "@material-ui/core/InputAdornment";

// core components
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import CustomInput from "components/CustomInput/CustomInput.js";
import IconButton from "@material-ui/core/IconButton";

const style = {
  infoText: {
    fontWeight: "300",
    margin: "10px 0 30px",
    textAlign: "center",
  },
  inputAdornmentIcon: {
    color: "#555",
  },
  inputAdornment: {
    position: "relative",
  },
};

class Step2 extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      credenciales: "",
      credencialesState: "",
      credencialesErrMsg: "",
      confirmarCredenciales: "",
      confirmarCredencialesState: "",
      confirmarCredencialesErrMsg: "",
      showPasswordCredenciales: false,
      showPasswordCredencialesCon: false,
      loadData: false,
      first: true,
    };
  }
  sendState() {
    return this.state;
  }
  handleClickShowPassword = () => {
    this.setState({
      showPasswordCredenciales: !this.state.showPasswordCredenciales,
    });
  };
  handleClickShowPasswordCon = () => {
    this.setState({
      showPasswordCredencialesCon: !this.state.showPasswordCredencialesCon,
    });
  };
  handleMouseDownPassword = (event) => {
    event.preventDefault();
  };
  // function that verifies if a string has a given length or not
  verifyLength(value, length) {
    if (value.length >= length) {
      return true;
    }
    return false;
  }
  change(event, stateName, type, stateNameEqualTo) {
    switch (stateName) {
      case "credenciales":
        if (
          event.target.value !== "" &&
          this.verifyLength(event.target.value, stateNameEqualTo) &&
          this.state.confirmarCredenciales === event.target.value
        ) {
          this.setState({
            first: false,
            [stateName]: event.target.value,
            [stateName + "State"]: "success",
            [stateName + "ErrMsg"]: "",
            confirmarCredencialesState: this.stateFn(
              this.state.confirmarCredenciales,
              event.target.value,
              "confirmarCredenciales",
              stateNameEqualTo
            ),
            confirmarCredencialesErrMsg: this.errMsgFn(
              this.state.confirmarCredenciales,
              event.target.value,
              "confirmarCredenciales",
              stateNameEqualTo
            ),
          });
        } else {
          this.setState({
            first: false,
            [stateName]: event.target.value,
            [stateName + "State"]: "error",
            [stateName + "ErrMsg"]: this.errMsgFn(
              event.target.value,
              this.state.confirmarCredenciales,
              stateName,
              stateNameEqualTo
            ),
            confirmarCredencialesState: this.stateFn(
              this.state.confirmarCredenciales,
              event.target.value,
              "confirmarCredenciales",
              stateNameEqualTo
            ),
            confirmarCredencialesErrMsg: this.errMsgFn(
              this.state.confirmarCredenciales,
              event.target.value,
              "confirmarCredenciales",
              stateNameEqualTo
            ),
          });
        }
        break;

      case "confirmarCredenciales":
        if (
          event.target.value !== "" &&
          this.state.credenciales === event.target.value
        ) {
          this.setState({
            first: false,
            [stateName]: event.target.value,
            [stateName + "State"]: "success",
            [stateName + "ErrMsg"]: "",
            credencialesState: this.stateFn(
              this.state.credenciales,
              event.target.value,
              "credenciales",
              stateNameEqualTo
            ),
            credencialesErrMsg: this.errMsgFn(
              this.state.credenciales,
              event.target.value,
              "credenciales",
              stateNameEqualTo
            ),
          });
        } else {
          this.setState({
            first: false,
            [stateName]: event.target.value,
            [stateName + "State"]: "error",
            [stateName + "ErrMsg"]: this.errMsgFn(
              event.target.value,
              this.state.credenciales,
              stateName,
              stateNameEqualTo
            ),
            credencialesState: this.stateFn(
              this.state.credenciales,
              event.target.value,
              "credenciales",
              stateNameEqualTo
            ),
            credencialesErrMsg: this.errMsgFn(
              this.state.credenciales,
              event.target.value,
              "credenciales",
              stateNameEqualTo
            ),
          });
        }
        break;
      default:
        break;
    }
  }

  stateFn(value, complemento, stateName, stateNameEqualTo) {
    switch (stateName) {
      case "credenciales":
        return value === ""
          ? "error"
          : !this.verifyLength(value, stateNameEqualTo)
          ? "error"
          : complemento !== value
          ? "error"
          : "success";
      case "confirmarCredenciales":
        return value === ""
          ? "error"
          : complemento !== value
          ? "error"
          : "success";
      default:
        break;
    }
  }
  errMsgFn(value, complemento, stateName, stateNameEqualTo) {
    switch (stateName) {
      case "credenciales":
        return value === ""
          ? "La credencial es requerida"
          : !this.verifyLength(value, stateNameEqualTo)
          ? "La credencial no cumple con los requisitos mínimos"
          : complemento !== value
          ? "Las credenciales no coinciden"
          : "";
      case "confirmarCredenciales":
        return value === ""
          ? "La confirmación de credencial es requerida"
          : complemento !== value
          ? "Las credenciales no coinciden"
          : "";
      default:
        break;
    }
  }

  isValidated(callback) {
    this.setState({ first: false });
    if (
      this.state.credencialesState === "success" &&
      this.state.confirmarCredencialesState === "success" &&
      this.state.loadData === false
    ) {
      this.state.loadData = true;
      SessionActions.TraerDatosUsuario(localStorage.getItem("token")).then(
        (responseDataUser) => {
          const credentials = {
            clave: this.state.credenciales,
            token: localStorage.getItem("token"),
          };

          CertificadoActions.credenciales(credentials).then((response) => {
            const { run, nombres, apellidos } = responseDataUser.data;
            const filename = `(${run}) ${nombres} ${apellidos}.pfx`;
            console.log(filename);

            const link = document.createElement("a");
            link.href = window.URL.createObjectURL(new Blob([response.data]));
            link.setAttribute("download", filename); //any other extension
            document.body.appendChild(link);
            link.click();
            link.remove();

            this.props.hasOwnProperty("onChangeData") &&
              this.props.onChangeData({
                token: credentials.token,
                password: credentials.clave,
              });

            callback(true);
          });
        }
      );
    } else {
      if (this.state.credencialesState !== "success") {
        this.setState({ credencialesState: "error" });
      }
      if (this.state.confirmarCredencialesState !== "success") {
        this.setState({ confirmarCredencialesState: "error" });
      }
    }

    callback(false);
  }
  render() {
    const { classes } = this.props;
    return (
      <GridContainer rowSpacing={0} justify="center">
        <GridItem xs={12} sm={12}>
          <h4
            className={classes.infoText}
            style={{ fontWeight: "400", marginBottom: "10px" }}
          >
            Crear Clave
          </h4>
          <h4 className={classes.infoText}>
            Cree la clave para acceder a su certificado digital
          </h4>
        </GridItem>
        <GridItem xs={12} sm={12} md={12} lg={10}>
          <CustomInput
            success={this.state.credencialesState === "success"}
            error={
              this.state.first
                ? false
                : this.state.credencialesState === "error"
            }
            errMsg={this.state.credencialesErrMsg}
            labelText={
              <span style={{ textTransform: "capitalize" }}>
                <span style={{ color: "red", paddingRight: "5px" }}>*</span>
                <span>Crear Clave</span>
              </span>
            }
            id="credenciales"
            formControlProps={{
              fullWidth: true,
            }}
            inputProps={{
              type: this.state.showPasswordCredenciales ? "text" : "password",
              onChange: (event) =>
                this.change(event, "credenciales", "length", 3),
              startAdornment: (
                <InputAdornment
                  position="start"
                  className={classes.inputAdornment}
                >
                  <IconButton
                    aria-label="toggle password visibility"
                    onClick={this.handleClickShowPassword}
                    onMouseDown={this.handleMouseDownPassword}
                  >
                    {this.state.showPasswordCredenciales ? (
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="1em"
                        height="1em"
                        viewBox="0 0 24 24"
                      >
                        <path
                          fill="currentColor"
                          d="M12 6a9.77 9.77 0 0 1 8.82 5.5C19.17 14.87 15.79 17 12 17s-7.17-2.13-8.82-5.5A9.77 9.77 0 0 1 12 6m0-2C7 4 2.73 7.11 1 11.5C2.73 15.89 7 19 12 19s9.27-3.11 11-7.5C21.27 7.11 17 4 12 4zm0 5a2.5 2.5 0 0 1 0 5a2.5 2.5 0 0 1 0-5m0-2c-2.48 0-4.5 2.02-4.5 4.5S9.52 16 12 16s4.5-2.02 4.5-4.5S14.48 7 12 7z"
                        />
                      </svg>
                    ) : (
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="1em"
                        height="1em"
                        viewBox="0 0 24 24"
                      >
                        <path
                          fill="currentColor"
                          d="M12 6a9.77 9.77 0 0 1 8.82 5.5a9.647 9.647 0 0 1-2.41 3.12l1.41 1.41c1.39-1.23 2.49-2.77 3.18-4.53C21.27 7.11 17 4 12 4c-1.27 0-2.49.2-3.64.57l1.65 1.65C10.66 6.09 11.32 6 12 6zm-1.07 1.14L13 9.21c.57.25 1.03.71 1.28 1.28l2.07 2.07c.08-.34.14-.7.14-1.07C16.5 9.01 14.48 7 12 7c-.37 0-.72.05-1.07.14zM2.01 3.87l2.68 2.68A11.738 11.738 0 0 0 1 11.5C2.73 15.89 7 19 12 19c1.52 0 2.98-.29 4.32-.82l3.42 3.42l1.41-1.41L3.42 2.45L2.01 3.87zm7.5 7.5l2.61 2.61c-.04.01-.08.02-.12.02a2.5 2.5 0 0 1-2.5-2.5c0-.05.01-.08.01-.13zm-3.4-3.4l1.75 1.75a4.6 4.6 0 0 0-.36 1.78a4.507 4.507 0 0 0 6.27 4.14l.98.98c-.88.24-1.8.38-2.75.38a9.77 9.77 0 0 1-8.82-5.5c.7-1.43 1.72-2.61 2.93-3.53z"
                        />
                      </svg>
                    )}
                  </IconButton>
                </InputAdornment>
              ),
            }}
          />
        </GridItem>
        <GridItem xs={12} sm={12} md={12} lg={10}>
          <CustomInput
            success={this.state.confirmarCredencialesState === "success"}
            error={
              this.state.first
                ? false
                : this.state.confirmarCredencialesState === "error"
            }
            errMsg={this.state.confirmarCredencialesErrMsg}
            labelText={
              <span style={{ textTransform: "capitalize" }}>
                <span style={{ color: "red", paddingRight: "5px" }}>*</span>
                <span>Confirmar Clave</span>
              </span>
            }
            id="confirmarCredenciales"
            formControlProps={{
              fullWidth: true,
            }}
            inputProps={{
              type: this.state.showPasswordCredencialesCon
                ? "text"
                : "password",
              onChange: (event) =>
                this.change(event, "confirmarCredenciales", "length", 3),
              startAdornment: (
                <InputAdornment
                  position="start"
                  className={classes.inputAdornment}
                >
                  <IconButton
                    aria-label="toggle password visibility"
                    onClick={this.handleClickShowPasswordCon}
                    onMouseDown={this.handleMouseDownPassword}
                  >
                    {this.state.showPasswordCredencialesCon ? (
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="1em"
                        height="1em"
                        viewBox="0 0 24 24"
                      >
                        <path
                          fill="currentColor"
                          d="M12 6a9.77 9.77 0 0 1 8.82 5.5C19.17 14.87 15.79 17 12 17s-7.17-2.13-8.82-5.5A9.77 9.77 0 0 1 12 6m0-2C7 4 2.73 7.11 1 11.5C2.73 15.89 7 19 12 19s9.27-3.11 11-7.5C21.27 7.11 17 4 12 4zm0 5a2.5 2.5 0 0 1 0 5a2.5 2.5 0 0 1 0-5m0-2c-2.48 0-4.5 2.02-4.5 4.5S9.52 16 12 16s4.5-2.02 4.5-4.5S14.48 7 12 7z"
                        />
                      </svg>
                    ) : (
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="1em"
                        height="1em"
                        viewBox="0 0 24 24"
                      >
                        <path
                          fill="currentColor"
                          d="M12 6a9.77 9.77 0 0 1 8.82 5.5a9.647 9.647 0 0 1-2.41 3.12l1.41 1.41c1.39-1.23 2.49-2.77 3.18-4.53C21.27 7.11 17 4 12 4c-1.27 0-2.49.2-3.64.57l1.65 1.65C10.66 6.09 11.32 6 12 6zm-1.07 1.14L13 9.21c.57.25 1.03.71 1.28 1.28l2.07 2.07c.08-.34.14-.7.14-1.07C16.5 9.01 14.48 7 12 7c-.37 0-.72.05-1.07.14zM2.01 3.87l2.68 2.68A11.738 11.738 0 0 0 1 11.5C2.73 15.89 7 19 12 19c1.52 0 2.98-.29 4.32-.82l3.42 3.42l1.41-1.41L3.42 2.45L2.01 3.87zm7.5 7.5l2.61 2.61c-.04.01-.08.02-.12.02a2.5 2.5 0 0 1-2.5-2.5c0-.05.01-.08.01-.13zm-3.4-3.4l1.75 1.75a4.6 4.6 0 0 0-.36 1.78a4.507 4.507 0 0 0 6.27 4.14l.98.98c-.88.24-1.8.38-2.75.38a9.77 9.77 0 0 1-8.82-5.5c.7-1.43 1.72-2.61 2.93-3.53z"
                        />
                      </svg>
                    )}
                  </IconButton>
                </InputAdornment>
              ),
            }}
          />
        </GridItem>
        <GridItem xs={12} sm={12}>
          <h4
            className={classes.infoText}
            style={{ fontWeight: "400", marginBottom: "10px" }}
          >
            ¡ IMPORTANTE !
          </h4>
        </GridItem>
        <GridItem xs={4} sm={4} md={12} lg={10}>
          <ul>
            <h4>
              <li>La Clave de un certificado NO se puede cambiar.</li>
              <li>
                Debe recordar esta clave durante toda la vigencia del
                certificado.
              </li>
              <li>
                Si olvida su clave, deberá pagar $3.000 para la emisión de un
                nuevo certificado, el que tendrá una vigencia de 1 año.
              </li>
            </h4>
          </ul>
        </GridItem>
      </GridContainer>
    );
  }
}

Step2.propTypes = {
  classes: PropTypes.object,
};

export default withStyles(style)(Step2);
